import { ErrorCode } from 'libs.react';
export const API_ERROR_MESSAGES = {
    [ErrorCode.ACCESS_DENIED_ACCOUNT_LOCKED]: {
        title: 'Account locked',
        subtitle: 'Your account has been temporarily locked. Please try again later.',
    },
    [ErrorCode.ACCESS_DENIED_SSO_REQUIRED]: {
        title: 'SSO required',
        subtitle: 'Password login is disabled for your account. Please use SSO to sign in.',
    },
    [ErrorCode.ACCESS_DENIED_INVALID_CREDENTIALS]: {
        title: 'Invalid credentials',
        subtitle: 'The email or password you entered is incorrect. Please check your credentials and try again. If you have forgotten your password, you can reset it using the "Forgot password" link.',
    },
    [ErrorCode.ACCESS_DENIED_PASSWORD_EXPIRED]: {
        title: 'Password expired',
        subtitle: 'The password has expired. Please check your credentials or try reset your password',
    },
    [ErrorCode.ACCESS_DENIED_INVALID_TOKEN]: {
        title: 'Session expired',
        subtitle: 'It seems like your session has expired or you have been signed out. Please sign in again to continue using the application.',
    },
    [ErrorCode.ACCESS_DENIED_REDEPLOYMENT]: {
        title: 'Error re-deploying study configuration',
        subtitle: 'The version you are trying to deploy requires deleting study configuration, deployment is not allowed, please contact Medable to request for assistance deploying this version.',
    },
    [ErrorCode.ACCESS_DENIED_TARGET_ORG]: {
        title: 'Access denied',
        subtitle: 'You do not have permission to update the environment. Please ask the owner of the environment to grant you Administrator permissions in the environment.',
    },
    [ErrorCode.ACCESS_DENIED_UPDATE_ENVIRONMENT_ACCESS]: {
        title: 'Access denied',
        subtitle: 'You do not have access to this environment. Ask your workspace or environment owner for access.',
    },
    [ErrorCode.ACCESS_DENIED_STUDY_DEPLOYMENT_ACCESS]: {
        title: 'Access denied',
        subtitle: 'You do not have permission to deploy to this environment. Ask your workspace or environment owner for access.',
    },
    [ErrorCode.ACCESS_DENIED_POLICY]: {
        title: 'Access denied',
        subtitle: 'You do not have permission to perform this action. Contact a workspace administrator for access.',
    },
    [ErrorCode.ACCESS_DENIED_LEGACY_STUDY]: {
        title: 'Action unavailable',
        subtitle: 'This action is not available for this study type.',
    },
    [ErrorCode.ACCESS_DENIED_NON_APPROVED_STUDY_DEPLOYMENT]: {
        title: 'Deployment not approved',
        subtitle: 'Only approved studies can be deployed to production.',
    },
    [ErrorCode.CONFLICT_ENVIRONMENT_NOT_PROVISIONED]: {
        title: 'Environment not provisioned',
        subtitle: 'The environment must be provisioned before you can complete this action.',
    },
    [ErrorCode.CONFLICT_ENVIRONMENT_PROVISION]: {
        title: 'Environment already exists',
        subtitle: 'This environment is already provisioned.',
    },
    [ErrorCode.CONFLICT_HIDE_NON_EPHEMERAL]: {
        title: 'Cannot archive environment',
        subtitle: 'Archive is only available for ephemeral environments.',
    },
    [ErrorCode.CONFLICT_HIDE_INVALID_STATUS]: {
        title: 'Cannot archive environment',
        subtitle: 'The environment cannot be archived in its current status.',
    },
    [ErrorCode.CONFLICT_INSTANCE_DELETE]: {
        title: 'Unable to delete study',
        subtitle: 'You are unable to delete a study with a sandbox or production environment. Please contact Medable for additional assistance.',
    },
    [ErrorCode.ENTITY_ACCESS_EXISTS]: {
        title: 'Duplicate email address',
        subtitle: 'The email provided already exists in this or other workspace. Email address must be unique across all Medable Workspaces. To resolve, use a different email address.',
    },
    [ErrorCode.EXISTING_SITE_IN_ENVIRONMENT]: {
        title: 'Site already exists in environment',
        subtitle: 'The selected site already exists in the environment. Please select a different site.',
    },
    [ErrorCode.ERROR_ENVIRONMENT_SITE_UPDATE]: {
        title: 'Unable to update site',
        subtitle: 'The site could not be updated in the environment. Please try again.',
    },
    [ErrorCode.ERROR_STUDY_CREATE]: {
        title: 'Unable to create study',
        subtitle: 'The study could not be created. Please try again.',
    },
    [ErrorCode.IDENTITY_NOT_VERIFIED]: {
        title: 'Identity not verified',
        subtitle: 'Your account has not been verified. Please verify your account by clicking the link in the email sent to you.',
    },
    [ErrorCode.PROD_ENVIRONMENT_LIMIT_REACHED]: {
        title: 'Unable to create a new deployment',
        subtitle: 'You have reached the limit of environments in the selected region. Please select a different region or use the Update feature to update any of your existing environments.',
    },
    [ErrorCode.PASSWORD_STRENGTH]: {
        title: 'Password strength',
        subtitle: 'Your password does not meet the minimum strength requirements. Use a stronger password to continue. Try a longer password, a phrase with random words, or add numbers and symbols to make it harder to guess.',
    },
    [ErrorCode.SITE_NUMBER_EXISTS]: {
        title: 'Site number already exists',
        subtitle: 'The site number you provided already exists. Please choose a different site number.',
    },
    [ErrorCode.USED_PASSWORD]: {
        title: 'Password already used',
        subtitle: 'You have used this password before. Please choose a password that you have not used before.',
    },
    [ErrorCode.INVALID_ARGUMENT_INVALID_TOKEN]: {
        title: 'Invalid or expired token',
        subtitle: 'This token is invalid or has expired. Please request a new one and try again.',
    },
    [ErrorCode.INVALID_ARGUMENT_SORT]: {
        title: 'Invalid sort',
        subtitle: 'The selected sort option is invalid.',
    },
    [ErrorCode.INVALID_ARGUMENT_CLUSTER_TYPE]: {
        title: 'Invalid environment type',
        subtitle: 'The selected environment type is not supported. Please choose a different environment type.',
    },
    [ErrorCode.INVALID_ARGUMENT_ROLE_GROUP]: {
        title: 'Invalid role group',
        subtitle: 'Select a valid role group and try again.',
    },
    [ErrorCode.INVALID_ARGUMENT_ENVIRONMENT_NOT_PROVISIONED]: {
        title: 'Environment not provisioned',
        subtitle: 'The environment must be provisioned before completing this action.',
    },
    [ErrorCode.INVALID_ARGUMENT_PROD_SITE_CAN_ONLY_BE_ADDED_TO_PROD_ENVS]: {
        title: 'Invalid site environment',
        subtitle: 'Prod sites can only be added to prod environments.',
    },
    [ErrorCode.INVALID_ARGUMENT_ADMIN_PASSWORD_SCORE]: {
        title: 'Password too weak',
        subtitle: 'The admin password does not meet the minimum security requirements.',
    },
    [ErrorCode.INVALID_ARGUMENT_BAYMAX_TEMPLATE]: {
        title: 'Invalid template',
        subtitle: 'The selected study template is not available.',
    },
    [ErrorCode.INVALID_ARGUMENT_SITE_TYPE_UPDATE]: {
        title: 'Cannot update site type',
        subtitle: 'Site type cannot be updated for sites used in production environments.',
    },
    [ErrorCode.NOT_FOUND_ENTITY]: {
        title: 'Workspace not found',
        subtitle: 'The requested workspace does not exist or you do not have access to it.',
    },
    [ErrorCode.NOT_FOUND_STUDY]: {
        title: 'Study not found',
        subtitle: 'The requested study does not exist or you do not have access to it.',
    },
    [ErrorCode.NOT_FOUND_ENVIRONMENT]: {
        title: 'Environment not found',
        subtitle: 'The requested environment does not exist or you do not have access to it.',
    },
    [ErrorCode.NOT_FOUND_ENVIRONMENT_SITE]: {
        title: 'Site not found in environment',
        subtitle: 'The requested site does not exist in this environment or you do not have access to it.',
    },
    [ErrorCode.NOT_FOUND_SITE]: {
        title: 'Site not found',
        subtitle: 'The requested site does not exist or you do not have access to it.',
    },
    [ErrorCode.NOT_FOUND_IDENTITY]: {
        title: 'User not found',
        subtitle: 'The requested user does not exist or you do not have access to their information.',
    },
    [ErrorCode.NOT_FOUND_ENTITY_ACCESS]: {
        title: 'User access not found',
        subtitle: 'The requested user does not have access to this workspace.',
    },
    [ErrorCode.NOT_FOUND_STUDY_CONFIG]: {
        title: 'Study configuration not found',
        subtitle: 'The requested study configuration does not exist or you do not have access to it.',
    },
    [ErrorCode.NOT_FOUND_WORKFLOW]: {
        title: 'Workflow not found',
        subtitle: 'The requested workflow does not exist or has expired.',
    },
    [ErrorCode.NOT_FOUND_IDP]: {
        title: 'Identity provider not found',
        subtitle: 'The requested identity provider does not exist or you do not have access to it.',
    },
};
export var ApiClientService;
(function (ApiClientService) {
    ApiClientService["IAM"] = "iam";
    ApiClientService["LIBRARY"] = "library";
    ApiClientService["MOM"] = "mom";
    ApiClientService["CLOUD"] = "cloud";
    ApiClientService["WEB"] = "web";
    ApiClientService["AUTOBUILD"] = "autobuild";
    ApiClientService["SG"] = "sg";
    ApiClientService["STAT"] = "stat";
    ApiClientService["CONTROL"] = "control";
    ApiClientService["AGENT_STUDIO_API"] = "agents";
    ApiClientService["AGENT_CHAT_API"] = "agent-chat";
    ApiClientService["SENTINEL"] = "sentinel";
})(ApiClientService || (ApiClientService = {}));
export const ApiClientEndpointsByService = {
    [ApiClientService.IAM]: process.env.IAM_SERVICE_ENDPOINT,
    [ApiClientService.LIBRARY]: process.env.LIBRARY_SERVICE_ENDPOINT,
    [ApiClientService.MOM]: process.env.MOM_SERVICE_ENDPOINT,
    [ApiClientService.CLOUD]: process.env.CLOUD_SERVICE_ENDPOINT,
    [ApiClientService.WEB]: process.env.WEB_ENDPOINT,
    [ApiClientService.AUTOBUILD]: process.env.AUTOBUILD_ENDPOINT,
    [ApiClientService.SG]: process.env.SG_SERVICE_ENDPOINT,
    [ApiClientService.STAT]: process.env.STUDY_TEST_AUTOMATION_TOOL_ENDPOINT,
    [ApiClientService.CONTROL]: process.env.CONTROL_SERVICE_ENDPOINT,
    [ApiClientService.AGENT_STUDIO_API]: process.env.AGENT_STUDIO_API_ENDPOINT,
    // Same agents-api host the @medable/assistant-ui chat talks to, at its root (sessions, threads).
    [ApiClientService.AGENT_CHAT_API]: process.env.NEXT_PUBLIC_API_URL,
    [ApiClientService.SENTINEL]: process.env.SENTINEL_SERVICE_ENDPOINT,
};
